<template>
  <!-- 請求書管理（売上） -->
  <div id="sales_management">
    <CCard>
      <CCardHeader>
        <h2>請求書管理</h2>
      </CCardHeader>

      <!-- 検索（サンプル画面と同じ） -->
      <CCardBody>
        <table class="table search-table">
          <tr>
            <th style="width: 100px">年月</th>
            <th style="width: 75px"></th>
            <th style="width: 50px"></th>
            <th></th>
          </tr>
          <tr>
            <td>
              <select class="custom-select" v-model="year" style="width: 90px">
                <option v-for="option in yearOption" :value="option.id" :key="option.id">
                  {{ option.name }}
                </option>
              </select>
            </td>
            <td>
              <select class="custom-select" v-model="month" style="width: 70px">
                <option v-for="option in monthOption" :value="option.id" :key="option.id">
                  {{ option.name }}
                </option>
              </select>
            </td>
            <td>請求書</td>
            <td>
              <button class="btn btn-primary" @click="callList">検索</button>
            </td>
          </tr>
        </table>
      </CCardBody>

      <!-- ここから下は「検索後に表示」 -->
      <template v-if="callFlg">
        <CCardHeader>
          <strong v-if="showYearMonth" style="font-size: 20px; font-weight: bold;">
            {{ selectYear }} 年 {{ selectMonth }} 月
          </strong>
          <div v-if="errors.length" style="margin-top: 6px;">
            <div style="color: red" v-for="e in errors" :key="e">{{ e }}</div>
          </div>
        </CCardHeader>

        <!-- 1) 未登録：検索後に新規フォーム -->
        <CCardBody v-if="mode === 'new'">
          <CCardHeader><strong>新規登録</strong></CCardHeader>

          <div class="table-responsive" v-if="formRows.length">
            <table class="table table-bordered">
              <thead>
                <tr>
                  <th rowspan="2" class="text-center">発行</th>
                  <th rowspan="2">スタッフ名</th>
                  <th rowspan="2">会社名</th>
                  <th rowspan="2" class="text-center">支払期限</th>
                  <th rowspan="2">プロジェクト名</th>
                  <th rowspan="2">項目補足</th>
                  <th rowspan="2" class="text-center">下限</th>
                  <th rowspan="2" class="text-center">上限</th>
                  <th colspan="3" class="text-center">単価（円）</th>
                  <th rowspan="2" class="text-center">精算（H）</th>
                  <th rowspan="2" class="text-center">売上（円）</th>
                  <th rowspan="2">その他経費</th>
                  <th rowspan="2">備考</th>
                </tr>
                <tr>
                  <th class="text-center">単価</th>
                  <th class="text-center">控除</th>
                  <th class="text-center">超過</th>
                </tr>
              </thead>

              <tbody>
                <tr v-for="(r, idx) in formRows" :key="formRowKey(r, idx)">
                  <td class="text-center">
                    <label class="custom-switch">
                      <input
                        type="checkbox"
                        class="custom-switch-input"
                        v-model="r.is_invoiced"
                      />
                      <span class="custom-switch-indicator"></span>
                    </label>
                  </td>
                  <td>{{ r.user_name }}</td>
                  <td v-if="r._showFormCompany" :rowspan="r._formCompanySpan">
                    {{ r.company_name }}
                  </td>
                  <td v-if="r._showFormDueDate" :rowspan="r._formDueDateSpan" class="cell-date">
                    <CInput type="date" v-model="r.due_date" @input="onCompanyDueDateInput(r)" />
                  </td>
                  <td v-if="r._showFormProject" :rowspan="r._formProjectSpan">
                    <CInput v-model="r.project_name" @input="onProjectNameInput(r)" class="project-name-input" />
                  </td>
                  <td class="cell-staff"><CInput v-model="r.staff_name" /></td>
                  <td class="cell-num">
                    <CInput class="text-right" v-model="r.base_time_min" @input="onBaseOrUnit(r)" />
                  </td>
                  <td class="cell-num">
                    <CInput class="text-right" v-model="r.base_time_max" @input="onBaseOrUnit(r)" />
                  </td>
                  <td class="cell-money">
                    <CInput class="text-right" v-model="r.unit_price" @input="onBaseOrUnit(r)" />
                  </td>

                  <td class="cell-money">
                    <CInput class="text-right" v-model="r.unit_price_deduct" @input="onDeductInput(r)" />
                  </td>
                  <td class="cell-money">
                    <CInput class="text-right" v-model="r.unit_price_excess" @input="onExcessInput(r)" />
                  </td>

                  <td class="cell-num">
                    <CInput class="text-right" v-model="r.settlement_time" @input="onSettlementInput(r)" />
                  </td>

                  <td class="cell-money">
                    <CInput class="text-right" v-model="r.amount_sales" @input="onSalesInput(r)" />
                  </td>
                  <td class="cell-other-expenses">
                    <div
                      v-for="(ex, exIdx) in r.other_expenses"
                      :key="expenseRowKey(r, exIdx)"
                      class="expense-row"
                    >
                      <CInput class="expense-item" v-model="ex.item_name" placeholder="項目名" />
                      <CInput class="expense-qty text-right" v-model="ex.qty" placeholder="数量" />
                      <CInput class="expense-unit" v-model="ex.unit" placeholder="単位" />
                      <CInput class="expense-price text-right" v-model="ex.unit_price" placeholder="単価" />
                      <CInput class="expense-amount text-right" v-model="ex.amount" placeholder="金額" />
                      <CInput class="expense-remarks" v-model="ex.remarks" placeholder="備考" />
                      <button type="button" class="btn btn-danger btn-sm ml-1" @click="removeOtherExpense(r, exIdx)">削除</button>
                    </div>
                    <button type="button" class="btn btn-info btn-sm mt-1" @click="addOtherExpense(r)">追加</button>
                  </td>
                  <td v-if="r._showFormRemarks" :rowspan="r._formRemarksSpan" class="cell-remarks">
                    <textarea
                      v-model="r.remarks"
                      @input="onCompanyRemarksInput(r)"
                      class="form-control remarks-textarea"
                      rows="4"
                    ></textarea>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="text-center mt-3">
            <button class="btn btn-secondary mr-2" :disabled="saving" @click="cancelToNone">キャンセル</button>
            <button class="btn btn-primary" :disabled="saving || formRows.length===0" @click="saveNew">登録</button>
          </div>
        </CCardBody>

        <!-- 2) 登録済：参照（請求書ボタンあり）＋更新ボタン -->
        <CCardBody v-else-if="mode === 'view'">
          <div class="d-flex justify-content-end align-items-center mb-2">
            <div class="mr-3 text-right">
              <div>単価合計：{{ formatNum(totalUnitPrice) }}</div>
              <div>売上合計：{{ formatNum(totalAmountSales) }}</div>
            </div>
            <button class="btn btn-primary" @click="startEdit">更新</button>
          </div>

          <div class="table-responsive">
            <table class="table table-bordered">
              <thead>
                <tr>
                  <th rowspan="2">
                    <div class="d-flex align-items-center justify-content-between">
                      <span>会社名</span>
                      <button class="btn btn-info btn-sm ml-2" @click="downloadAllCompanyInvoices">一括ダウンロード</button>
                    </div>
                  </th>
                  <th rowspan="2">支払期限</th>
                  <th rowspan="2">プロジェクト名</th>
                  <th rowspan="2">項目補足</th>
                  <th colspan="3" class="text-center">単価（円）</th>
                  <th rowspan="2" class="text-center">精算時間（H）</th>
                  <th rowspan="2" class="text-center">売上（円）</th>
                  <th rowspan="2">その他経費</th>
                  <th rowspan="2">備考</th>
                </tr>
                <tr>
                  <th class="text-center">単価</th>
                  <th class="text-center">控除</th>
                  <th class="text-center">超過</th>
                </tr>
              </thead>

              <tbody>
                <tr v-for="(r, idx) in viewRows" :key="rowKey(r, idx)">
                  <td v-if="r._showCompany" :rowspan="r._companySpan">
                    <div class="d-flex align-items-center justify-content-between">
                      <div class="d-flex align-items-center">
                        <span>{{ r.company_name }}</span>
                      </div>
                      <button class="btn btn-info btn-sm ml-2" @click="openInvoice('company', r.company_id)">請求書</button>
                    </div>
                  </td>

                  <td v-if="r._showDueDate" :rowspan="r._dueDateSpan" class="text-center">
                    {{ r.due_date ? r.due_date.replace(/-/g, "/") : "" }}
                  </td>

                  <td v-if="r._showProject" :rowspan="r._projectSpan">
                    <div class="d-flex align-items-center justify-content-between">
                      <span>{{ r.project_name }}</span>
                      <button class="btn btn-info btn-sm ml-2" @click="openInvoice('project', r.project_id)">請求書</button>
                    </div>
                  </td>

                  <td>
                    <div class="d-flex align-items-center justify-content-between">
                      <span>{{ r.staff_name }}</span>
                      <button class="btn btn-info btn-sm ml-2" @click="openInvoice('user', r.user_id, r._invoiceCompanyId)">請求書</button>
                    </div>
                  </td>

                  <td class="text-right">{{ formatNum(r.unit_price) }}</td>
                  <td class="text-right">{{ formatNum(r.unit_price_deduct) }}</td>
                  <td class="text-right">{{ formatNum(r.unit_price_excess) }}</td>
                  <td class="text-right">{{ formatNum(r.settlement_time) }}</td>
                  <td class="text-right">{{ formatNum(r.amount_sales) }}</td>
                  <td class="cell-other-expenses">
                    <div v-if="r.other_expenses && r.other_expenses.length">
                      <div
                        v-for="(ex, exIdx) in r.other_expenses"
                        :key="expenseRowKey(r, exIdx)"
                        class="expense-view-row"
                      >
                        <div>
                          【{{ ex.item_name || "—" }}】
                          {{ formatNum(ex.unit_price) }}円 X {{ formatNum(ex.qty) }}{{ ex.unit || "" }}
                          = {{ formatNum(ex.amount) }}円
                        </div>
                        <div v-if="ex.remarks">{{ ex.remarks }}</div>
                      </div>
                    </div>
                    <div v-else>—</div>
                  </td>
                  <td v-if="r._showViewRemarks" :rowspan="r._viewRemarksSpan">
                    {{ r.remarks }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </CCardBody>

        <!-- 3) 更新：新規と同じ形式の入力フォーム -->
        <CCardBody v-else-if="mode === 'edit'">
          <CCardHeader><strong>更新</strong></CCardHeader>

          <div class="table-responsive" v-if="formRows.length">
            <table class="table table-bordered">
              <thead>
                <tr>
                  <th rowspan="2" class="text-center">発行</th>
                  <th rowspan="2">スタッフ名</th>
                  <th rowspan="2">会社名</th>
                  <th rowspan="2" class="text-center">支払期限</th>
                  <th rowspan="2">プロジェクト名</th>
                  <th rowspan="2">項目補足</th>
                  <th rowspan="2" class="text-center">下限</th>
                  <th rowspan="2" class="text-center">上限</th>
                  <th colspan="3" class="text-center">単価（円）</th>
                  <th rowspan="2" class="text-center">精算（H）</th>
                  <th rowspan="2" class="text-center">売上（円）</th>
                  <th rowspan="2">その他経費</th>
                  <th rowspan="2">/処理フロー</th>
                </tr>
                <tr>
                  <th class="text-center">単価</th>
                  <th class="text-center">控除</th>
                  <th class="text-center">超過</th>
                </tr>
              </thead>

              <tbody>
                <tr v-for="(r, idx) in formRows" :key="formRowKey(r, idx)">
                  <td class="text-center">
                    <label class="custom-switch">
                      <input
                        type="checkbox"
                        class="custom-switch-input"
                        v-model="r.is_invoiced"
                      />
                      <span class="custom-switch-indicator"></span>
                    </label>
                  </td>
                  <td>{{ r.user_name }}</td>
                  <td v-if="r._showFormCompany" :rowspan="r._formCompanySpan">
                    {{ r.company_name }}
                  </td>
                  <td v-if="r._showFormDueDate" :rowspan="r._formDueDateSpan" class="cell-date">
                    <CInput type="date" v-model="r.due_date" @input="onCompanyDueDateInput(r)" />
                  </td>
                  <td v-if="r._showFormProject" :rowspan="r._formProjectSpan">
                    <CInput v-model="r.project_name" @input="onProjectNameInput(r)" class="project-name-input" />
                  </td>
                  <td class="cell-staff"><CInput v-model="r.staff_name" /></td>
                  <td class="cell-num">
                    <CInput class="text-right" v-model="r.base_time_min" @input="onBaseOrUnit(r)" />
                  </td>
                  <td class="cell-num">
                    <CInput class="text-right" v-model="r.base_time_max" @input="onBaseOrUnit(r)" />
                  </td>
                  <td class="cell-money">
                    <CInput class="text-right" v-model="r.unit_price" @input="onBaseOrUnit(r)" />
                  </td>

                  <td class="cell-money">
                    <CInput class="text-right" v-model="r.unit_price_deduct" @input="onDeductInput(r)" />
                  </td>
                  <td class="cell-money">
                    <CInput class="text-right" v-model="r.unit_price_excess" @input="onExcessInput(r)" />
                  </td>

                  <td class="cell-num">
                    <CInput class="text-right" v-model="r.settlement_time" @input="onSettlementInput(r)" />
                  </td>

                  <td class="cell-money">
                    <CInput class="text-right" v-model="r.amount_sales" @input="onSalesInput(r)" />
                  </td>
                  <td class="cell-other-expenses">
                    <div
                      v-for="(ex, exIdx) in r.other_expenses"
                      :key="expenseRowKey(r, exIdx)"
                      class="expense-row"
                    >
                      <CInput class="expense-item" v-model="ex.item_name" placeholder="項目名" />
                      <CInput class="expense-qty text-right" v-model="ex.qty" placeholder="数量" />
                      <CInput class="expense-unit" v-model="ex.unit" placeholder="単位" />
                      <CInput class="expense-price text-right" v-model="ex.unit_price" placeholder="単価" />
                      <CInput class="expense-amount text-right" v-model="ex.amount" placeholder="金額" />
                      <CInput class="expense-remarks" v-model="ex.remarks" placeholder="備考" />
                      <button type="button" class="btn btn-danger btn-sm ml-1" @click="removeOtherExpense(r, exIdx)">削除</button>
                    </div>
                    <button type="button" class="btn btn-info btn-sm mt-1" @click="addOtherExpense(r)">追加</button>
                  </td>
                  <td v-if="r._showFormRemarks" :rowspan="r._formRemarksSpan" class="cell-remarks">
                    <textarea
                      v-model="r.remarks"
                      @input="onCompanyRemarksInput(r)"
                      class="form-control remarks-textarea"
                      rows="4"
                    ></textarea>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="text-center mt-3">
            <button class="btn btn-secondary mr-2" :disabled="saving" @click="cancelEdit">キャンセル</button>
            <button class="btn btn-primary" :disabled="saving || formRows.length===0" @click="saveEdit">更新</button>
          </div>
        </CCardBody>

        <!-- 初期（検索前など） -->
        <CCardBody v-else>
          <div>検索してください。</div>
        </CCardBody>
      </template>
    </CCard>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import ConstList from "../../ConstList";

export default {
  name: "SalesManagement",

  data() {
    return {
      year: "",
      month: "",
      yearOption: [],
      monthOption: [],

      callFlg: false,
      showYearMonth: false,
      selectYear: "",
      selectMonth: "",

      mode: "", // '' | 'new' | 'view' | 'edit'
      rows: [],
      viewRows: [],
      formRows: [],

      errors: [],
      saving: false,
    };
  },

  created() {
    this.yearOption = ConstList.YEAR_OPTION;
    this.monthOption = ConstList.MONTH_OPTION;
  },

  mounted() {
    if (Object.prototype.hasOwnProperty.call(sessionStorage, "sales-search-params")) {
      const params = JSON.parse(sessionStorage.getItem("sales-search-params"));
      this.year = params.year;
      this.month = params.month;
      this.callList();
      return;
    }

    let today = moment();
    if (today.date() < 10) {
      today = today.subtract(1, "months");
    }
    this.year = today.format("YYYY");
    this.month = today.format("M");
  },

  methods: {
    callList: function () {
      this.errors = [];
      this.callFlg = false;
      this.showYearMonth = true;
      this.selectYear = this.year;
      this.selectMonth = this.month;

      this.mode = "";
      this.rows = [];
      this.viewRows = [];
      this.formRows = [];

      axios
        .get(process.env.VUE_APP_API_ORIGIN + "/sales/list", {
          params: { year: this.year, month: this.month },
        })
        .then((res) => {
          const exists = !!res.data.exists;

          if (!exists) {
            this.mode = "new";
            this.callFlg = true;
            sessionStorage.setItem("sales-search-params", JSON.stringify({ year: this.year, month: this.month }));
            this.loadInitRows();
            return;
          }

          // 登録済：参照表示（DB保存値をそのまま表示する想定）
          this.rows = (res.data.items || []).map((r) => {
            const row = { ...r };
            row.is_invoiced = (row.is_invoiced === true);
            row.due_date = row.due_date || "";
            row.project_name = row.project_name || "";
            row.staff_name = row.staff_name || row.user_name || "";
            row.other_expenses = this.normalizeOtherExpenses(row.other_expenses);
            row._manual = { deduct: false, excess: false, sales: false };
            return row;
          });

          this.viewRows = this.buildRowspan(this.rows.filter((r) => r.is_invoiced === true));
          this.mode = "view";
          this.callFlg = true;

          sessionStorage.setItem("sales-search-params", JSON.stringify({ year: this.year, month: this.month }));
        })
        .catch((error) => {
          axios
            .get(`${process.env.VUE_APP_API_ORIGIN}/error/frontError/${encodeURIComponent(error.message || String(error))}`)
            .then(() => alert(ConstList.SYSTEM_ERROR))
            .catch(() => alert(ConstList.SYSTEM_COMMUNICATION_ERROR));
        });
    },

    loadInitRows: function () {
      axios
        .get(process.env.VUE_APP_API_ORIGIN + "/sales/init", {
          params: { year: this.year, month: this.month },
        })
        .then((res) => {
          const items = res.data.items || [];
          this.formRows = this.buildFormCompanyRowspan(items.map((r) => {
            const row = { ...r };
            row.unit_price = (row.unit_price ?? 0);
            row.amount_cost = (row.amount_cost ?? 0);
            row.settlement_time = (row.settlement_time ?? 0);
            row.unit_price_deduct = (row.unit_price_deduct ?? 0);
            row.unit_price_excess = (row.unit_price_excess ?? 0);
            row.amount_sales = (row.amount_sales ?? 0);
            row.remarks = (row.remarks ?? "");
            row.is_invoiced = true;
            row.due_date = row.due_date || "";
            row.project_name = row.project_name || "";
            row.staff_name = row.staff_name || row.user_name || "";
            row.other_expenses = this.normalizeOtherExpenses(row.other_expenses);
            row._manual = { deduct: false, excess: false, sales: false };
            return row;
          }));

          // 初期自動計算
          this.formRows.forEach((r) => {
            this.autoCalcDeductExcess(r);
            this.autoCalcSales(r);
          });
        })
        .catch((error) => {
          axios
            .get(`${process.env.VUE_APP_API_ORIGIN}/error/frontError/${encodeURIComponent(error.message || String(error))}`)
            .then(() => alert(ConstList.SYSTEM_ERROR))
            .catch(() => alert(ConstList.SYSTEM_COMMUNICATION_ERROR));
        });
    },

    startEdit: function () {
      this.mode = "edit";
      this.formRows = this.buildFormCompanyRowspan(this.rows.map((r) => {
        const row = { ...r };
        row.is_invoiced = (row.is_invoiced === true);
        row.due_date = row.due_date || "";
        row.project_name = row.project_name || "";
        row.staff_name = row.staff_name || row.user_name || "";
        row.other_expenses = this.normalizeOtherExpenses(row.other_expenses);
        row._manual = { deduct: false, excess: false, sales: false };
        return row;
      }));
    },

    cancelEdit: function () {
      this.mode = "view";
      this.viewRows = this.buildRowspan(this.rows.filter((r) => r.is_invoiced === true));
    },

    cancelToNone: function () {
      this.mode = "";
    },

    saveNew: function () {
      if (this.saving) return;
      this.saving = true;

      const normalizedRows = this.normalizeCompanyFields(this.formRows);

      const items = normalizedRows.map((r) => ({
        user_id: r.user_id,
        project_id: r.project_id,
        project_name: r.project_name || "",
        due_date: r.due_date || null,
        staff_name: r.staff_name || "",
        unit_price: this.toNum(r.unit_price),
        settlement_time: this.toNum(r.settlement_time),
        unit_price_deduct: this.toNum(r.unit_price_deduct),
        unit_price_excess: this.toNum(r.unit_price_excess),
        amount_sales: this.toNum(r.amount_sales),
        amount_cost: this.toNum(r.amount_cost),
        remarks: r.remarks || "",
        is_invoiced: r.is_invoiced === true,
        other_expenses: this.buildOtherExpensePayload(r),
      }));

      axios
        .post(process.env.VUE_APP_API_ORIGIN + "/sales/register", {
          year: this.year,
          month: this.month,
          items: items,
        })
        .then(() => {
          alert(ConstList.REGISTER_MESSAGE);
          this.callList();
        })
        .catch((error) => {
          axios
            .get(`${process.env.VUE_APP_API_ORIGIN}/error/frontError/${encodeURIComponent(error.message || String(error))}`)
            .then(() => alert(ConstList.SYSTEM_ERROR))
            .catch(() => alert(ConstList.SYSTEM_COMMUNICATION_ERROR));
        })
        .finally(() => {
          this.saving = false;
        });
    },

    saveEdit: function () {
      if (this.saving) return;
      this.saving = true;

      const normalizedRows = this.normalizeCompanyFields(this.formRows);

      const items = normalizedRows.map((r) => ({
        id: r.id,
        due_date: r.due_date || null,
        project_name: r.project_name || "",
        staff_name: r.staff_name || "",
        unit_price: this.toNum(r.unit_price),
        settlement_time: this.toNum(r.settlement_time),
        unit_price_deduct: this.toNum(r.unit_price_deduct),
        unit_price_excess: this.toNum(r.unit_price_excess),
        amount_sales: this.toNum(r.amount_sales),
        amount_cost: this.toNum(r.amount_cost),
        remarks: r.remarks || "",
        is_invoiced: r.is_invoiced === true,
        other_expenses: this.buildOtherExpensePayload(r),
      }));

      axios
        .post(process.env.VUE_APP_API_ORIGIN + "/sales/update", {
          year: this.year,
          month: this.month,
          items: items,
        })
        .then(() => {
          alert(ConstList.REGISTER_MESSAGE);
          this.callList();
        })
        .catch((error) => {
          axios
            .get(`${process.env.VUE_APP_API_ORIGIN}/error/frontError/${encodeURIComponent(error.message || String(error))}`)
            .then(() => alert(ConstList.SYSTEM_ERROR))
            .catch(() => alert(ConstList.SYSTEM_COMMUNICATION_ERROR));
        })
        .finally(() => {
          this.saving = false;
        });
    },

    // 単価/下限/上限が変わったら → 手入力は意味がなくなるので自動計算へ戻す
    onBaseOrUnit: function (r) {
      if (!r._manual) r._manual = { deduct: false, excess: false, sales: false };
      r._manual.deduct = false;
      r._manual.excess = false;
      r._manual.sales = false;

      this.autoCalcDeductExcess(r);
      this.autoCalcSales(r);
    },

    // 控除/超過/売上 を「入力したら」手動扱いにする
    onDeductInput: function (r) {
      if (!r._manual) r._manual = { deduct: false, excess: false, sales: false };
      r._manual.deduct = true;
      this.autoCalcSales(r);
    },

    onExcessInput: function (r) {
      if (!r._manual) r._manual = { deduct: false, excess: false, sales: false };
      r._manual.excess = true;
      this.autoCalcSales(r);
    },

    onSalesInput: function (r) {
      if (!r._manual) r._manual = { deduct: false, excess: false, sales: false };
      r._manual.sales = true;
    },

    onSettlementInput: function (r) {
      this.autoCalcSales(r);
    },

    // 控除/超過 自動計算（10円単位：控除=切上げ、超過=切捨て、10円未満は0）
    // 控除：単価 / 下限（切上げ）
    // 超過：単価 / 上限（切捨て）
    autoCalcDeductExcess: function (r) {
      const unit = this.toNum(r.unit_price);
      const min = this.toNum(r.base_time_min);
      const max = this.toNum(r.base_time_max);

      if (!(r._manual && r._manual.deduct)) {
        const v = (min > 0) ? (unit / min) : 0;
        r.unit_price_deduct = (v < 10) ? 0 : this.ceil10(v);
      }

      if (!(r._manual && r._manual.excess)) {
        const v = (max > 0) ? (unit / max) : 0;
        r.unit_price_excess = (v < 10) ? 0 : this.floor10(v);
      }
    },

    // 売上 自動計算（手動入力したら固定）
    // 精算=0 → 単価
    // 精算>0 → 単価 + 超過*精算
    // 精算<0 → 単価 + 控除*精算
    autoCalcSales: function (r) {
      if (r._manual && r._manual.sales) return;

      const settlement = this.toNum(r.settlement_time);
      const unit = this.toNum(r.unit_price);
      const deduct = this.toNum(r.unit_price_deduct);
      const excess = this.toNum(r.unit_price_excess);

      if (settlement === 0) {
        r.amount_sales = unit;
        return;
      }
      if (settlement > 0) {
        r.amount_sales = unit + excess * settlement;
        return;
      }
      r.amount_sales = unit + deduct * settlement;
    },

    buildRowspan: function (rows) {
      const out = rows.map((r) => ({
        ...r,
        _showCompany: false,
        _companySpan: 1,
        _showDueDate: false,
        _dueDateSpan: 1,
        _showProject: false,
        _projectSpan: 1,
        _showViewRemarks: false,
        _viewRemarksSpan: 1,
        _invoiceCompanyId: r.company_id || null,
      }));

      let i = 0;
      while (i < out.length) {
        const cid = out[i].company_id;
        let j = i;
        while (j < out.length && out[j].company_id === cid) j++;

        out[i]._showCompany = true;
        out[i]._companySpan = j - i;
        out[i]._showDueDate = true;
        out[i]._dueDateSpan = j - i;
        out[i]._showViewRemarks = true;
        out[i]._viewRemarksSpan = j - i;

        for (let n = i; n < j; n++) {
          out[n]._invoiceCompanyId = cid;
        }

        let k = i;
        while (k < j) {
          const pid = out[k].project_id;
          let m = k;
          while (m < j && out[m].project_id === pid) m++;

          out[k]._showProject = true;
          out[k]._projectSpan = m - k;

          k = m;
        }
        i = j;
      }
      return out;
    },

    buildFormCompanyRowspan: function (rows) {
      const out = rows.map((r) => ({
        ...r,
        _showFormCompany: false,
        _formCompanySpan: 1,
        _showFormDueDate: false,
        _formDueDateSpan: 1,
        _showFormProject: false,
        _formProjectSpan: 1,
        _showFormRemarks: false,
        _formRemarksSpan: 1,
      }));

      let i = 0;
      while (i < out.length) {
        const cid = out[i].company_id;
        let j = i;
        while (j < out.length && out[j].company_id === cid) j++;

        out[i]._showFormCompany = true;
        out[i]._formCompanySpan = j - i;
        out[i]._showFormDueDate = true;
        out[i]._formDueDateSpan = j - i;
        out[i]._showFormRemarks = true;
        out[i]._formRemarksSpan = j - i;

        let k = i;
        while (k < j) {
          const pid = out[k].project_id;
          let m = k;
          while (m < j && out[m].project_id === pid) m++;

          out[k]._showFormProject = true;
          out[k]._formProjectSpan = m - k;

          k = m;
        }

        i = j;
      }
      return out;
    },

    onCompanyDueDateInput: function (r) {
      this.formRows.forEach((row) => {
        if (row.company_id === r.company_id) {
          row.due_date = r.due_date || "";
        }
      });
    },

    onCompanyRemarksInput: function (r) {
      this.formRows.forEach((row) => {
        if (row.company_id === r.company_id) {
          row.remarks = r.remarks || "";
        }
      });
    },

    normalizeCompanyFields: function (rows) {
      const firstByCompany = {};

      rows.forEach((r) => {
        if (!Object.prototype.hasOwnProperty.call(firstByCompany, r.company_id)) {
          firstByCompany[r.company_id] = {
            due_date: r.due_date || "",
            remarks: r.remarks || "",
          };
        }
      });

      return rows.map((r) => ({
        ...r,
        due_date: firstByCompany[r.company_id].due_date,
        remarks: firstByCompany[r.company_id].remarks,
      }));
    },

    formRowKey: function (r, idx) {
      return `${r.company_id}-${r.project_id}-${r.user_id}-${idx}`;
    },

    rowKey: function (r, idx) {
      return `${r.id || 0}-${r.company_id}-${r.project_id}-${r.user_id}-${idx}`;
    },

    openInvoice: function (scope, id, companyId) {
      const params = { year: this.year, month: this.month, scope: scope };
      if (scope === "company") params.company_id = id;
      if (scope === "project") params.project_id = id;
      if (scope === "user") {
        if (!companyId) {
          alert("会社IDの取得に失敗しました。再検索してください。");
          return;
        }
        params.user_id = id;
        params.company_id = companyId;
      }

      axios
        .get(process.env.VUE_APP_API_ORIGIN + "/sales/invoice/pdf", {
          params: params,
          responseType: "blob",
        })
        .then((res) => {
          const blob = new Blob([res.data], { type: "application/pdf" });
          const blobUrl = URL.createObjectURL(blob);
          window.open(blobUrl, "_blank");
        })
        .catch((error) => {
          axios
            .get(`${process.env.VUE_APP_API_ORIGIN}/error/frontError/${encodeURIComponent(error.message || String(error))}`)
            .then(() => alert(ConstList.SYSTEM_ERROR))
            .catch(() => alert(ConstList.SYSTEM_COMMUNICATION_ERROR));
        });
    },

    toNum: function (v) {
      const n = Number(v);
      if (!Number.isFinite(n)) return 0;
      return n;
    },

    floor10: function (v) {
      const n = Number(v);
      if (!Number.isFinite(n) || n <= 0) return 0;
      return Math.floor(n / 10) * 10;
    },

    ceil10: function (v) {
      const n = Number(v);
      if (!Number.isFinite(n) || n <= 0) return 0;
      return Math.ceil(n / 10) * 10;
    },

    formatNum: function (v) {
      const n = this.toNum(v);
      return n.toLocaleString();
    },
    normalizeOtherExpenses: function (expenses) {
      if (!Array.isArray(expenses) || expenses.length === 0) {
        return [];
      }
      return expenses.map((ex) => ({
        item_name: ex.item_name || "",
        qty: (ex.qty ?? 1),
        unit: ex.unit || "式",
        unit_price: (ex.unit_price ?? 0),
        amount: (ex.amount ?? 0),
        remarks: ex.remarks || "",
      }));
    },

    buildOtherExpensePayload: function (r) {
      return (r.other_expenses || []).map((ex) => ({
        item_name: ex.item_name || "",
        qty: this.toNum(ex.qty),
        unit: ex.unit || "式",
        unit_price: this.toNum(ex.unit_price),
        amount: this.toNum(ex.amount),
        remarks: ex.remarks || "",
      }));
    },

    newOtherExpenseRow: function () {
      return {
        item_name: "",
        qty: 1,
        unit: "式",
        unit_price: 0,
        amount: 0,
        remarks: "",
      };
    },
    addOtherExpense: function (r) {
      if (!Array.isArray(r.other_expenses)) {
        r.other_expenses = [];
      }
      r.other_expenses.push(this.newOtherExpenseRow());
    },
    removeOtherExpense: function (r, idx) {
      if (!Array.isArray(r.other_expenses)) {
        return;
      }
      r.other_expenses.splice(idx, 1);
    },
    expenseRowKey: function (r, idx) {
      return `${r.id || 0}-${r.company_id}-${r.project_id}-${r.user_id}-expense-${idx}`;
    },
    downloadAllCompanyInvoices: function () {
      const companyIds = this.viewRows
        .filter((r) => r._showCompany)
        .map((r) => r.company_id);

      if (companyIds.length === 0) {
        alert("ダウンロード対象の会社がありません。");
        return;
      }

      axios
        .post(process.env.VUE_APP_API_ORIGIN + "/sales/invoice/zip", {
          year: this.year,
          month: this.month,
          company_ids: companyIds,
        }, {
          responseType: "blob",
        })
        .then((res) => {
          const blob = new Blob([res.data], { type: "application/zip" });
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.download = `sales_invoice_${this.year}${String(this.month).padStart(2, "0")}.zip`;
          document.body.appendChild(link);
          link.click();
          link.remove();
          window.URL.revokeObjectURL(url);
        })
        .catch((error) => {
          axios
            .get(`${process.env.VUE_APP_API_ORIGIN}/error/frontError/${encodeURIComponent(error.message || String(error))}`)
            .then(() => alert(ConstList.SYSTEM_ERROR))
            .catch(() => alert(ConstList.SYSTEM_COMMUNICATION_ERROR));
        });
    },
    onProjectNameInput: function (r) {
      this.formRows.forEach((row) => {
        if (row.project_id === r.project_id) {
          row.project_name = r.project_name || "";
        }
      });
    },
  },

  computed: {
    totalUnitPrice: function () {
      return (this.rows || [])
        .filter((r) => r.is_invoiced === true)
        .reduce((sum, r) => sum + this.toNum(r.unit_price), 0);
    },
    totalAmountSales: function () {
      return (this.rows || [])
        .filter((r) => r.is_invoiced === true)
        .reduce((sum, r) => sum + this.toNum(r.amount_sales), 0);
    },
  },
};
</script>

<style scoped>
td,
th {
  white-space: nowrap;
  vertical-align: middle;
}
.text-right {
  text-align: right;
}
.cell-date {
  min-width: 165px;
}
.cell-staff {
  min-width: 160px;
}
.project-name-input {
  min-width: 220px;
}
.cell-num {
  min-width: 90px;
}
.cell-money {
  min-width: 120px;
}
.cell-remarks {
  min-width: 220px;
}
.cell-other-expenses {
  min-width: 520px;
  vertical-align: top;
}
.expense-row {
  display: flex;
  align-items: center;
  margin-bottom: 4px;
}
.expense-item {
  min-width: 120px;
}
.expense-qty {
  min-width: 70px;
}
.expense-unit {
  min-width: 70px;
}
.expense-price {
  min-width: 90px;
}
.expense-amount {
  min-width: 90px;
}
.expense-remarks {
  min-width: 140px;
}
.expense-view-row {
  margin-bottom: 8px;
  white-space: normal;
}
</style>
